<template>
  <VueLoadingOverlay :active.sync="isLoading" :is-full-page="true"> </VueLoadingOverlay>
</template>

<script>
  import { GetIdsByCustomerIds } from '@/services/customer-support/account'
  import { showMess } from '@/config/utils'
  import gzip from 'gzip-js'

  export default {
    // props: {
    //   level: {
    //     type: String,
    //     default: null,
    //   },
    // },
    data() {
      return {
        isLoading: false,
        ids: [],
      }
    },
    async created() {
      const encodedData = this.$route.query.ids
      if (encodedData) {
        const compressed = Uint8Array.from(atob(encodedData), c => c.charCodeAt(0))
        const decompressed = gzip.unzip(compressed)
        const sIds = String.fromCharCode(...decompressed)
        this.ids = sIds.split(/,/g)
      } else {
        showMess(
          this,
          'Thông báo',
          'Không có thông tin đối tượng cần gán',
          'danger',
          'b-toaster-top-right',
          5 * 60 * 60
        )
      }
    },

    async mounted() {
      if (!this.ids || this.ids.length === 0)
        return showMess(
          this,
          'Thông báo',
          'Không có đối tượng để gán',
          'danger',
          'b-toaster-top-right',
          5 * 60 * 60
        )
      await this.loadData()
    },

    methods: {
      async loadData() {
        try {
          this.isLoading = true
          const res = await GetIdsByCustomerIds(this.ids)
          if (res.code === 1000) {
            const listIds = Object.values(res.data)
            this.redirect(listIds)
          } else {
            showMess(
              this,
              'Thông báo',
              `#${res.code}: ${res.message}`,
              res.message,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (e) {
          showMess(this, 'Thông báo', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },

      redirect(listIds) {
        if (listIds.length > 0) {
          const gzipData = gzip.zip(listIds.join(','), {
            level: 9,
          })
          const encodedString = btoa(String.fromCharCode(...gzipData))
          this.$router.replace({
            path: `/customer-support/add-task-merchant`,
            query: { ids: encodedString },
          })
        } else {
          showMess(
            this,
            'Thông báo',
            'Dữ liệu khi chuyển đổi không được đồng bộ',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
    },
  }
</script>
